import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { MadfarmInput } from '../../../../ui/molecules/input/newInput'
import { ProtocolSelectByObject } from '../../../../ui/molecules/ProtocolSelectByObj'
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static'
import TextArea from '../../../../ui/molecules/textArea'
import { tipologiaRichiestaComplianceRequest } from '../../../../utils'
import { CustomersOtherOdCAdd } from '../components/extCustomers'
import { setRequestDescription, setRequestNote, setRequestProduct, setRequestProtocolId, setRequestSender, setRequestType } from '../slice'
import '../styles.scss'

export function AddFormRequest() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const complianceRequestState = useAppSelector(state => state.complianceRequest)

    return (
        <div className="flex flex-col gap-6 p-4">
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Richieste di Conformità / Richiesta</span>
                </div>
                <div className="p-6 flex flex-col gap-4">
                    <ProtocolSelectByObject
                        objectId='138'
                        error={complianceRequestState.complianceRequestErrors.requestProtocolId}
                        errorLabel='Inserire protocollo richiesta'
                        customerId={sessionState.selected.customerId!}
                        placeholder='Seleziona protocollo...'
                        type='entry'
                        onChange={(value) => dispatch(setRequestProtocolId(value))}
                    />
                    <MadfarmInput
                        label="Mittente"
                        error={complianceRequestState.complianceRequestErrors.sender}
                        supportingText={complianceRequestState.complianceRequestErrors.sender ? 'Indicare Mittente' : undefined}
                        placeholder="Mittente"
                        onChangeText={(text) => { dispatch(setRequestSender(text)) }}
                    />
                    <div className="border-[0.5px] border-neutral-200" />
                    <div className='grid grid-cols-2 gap-6'>
                        <MadfarmStaticSelect
                            noOptionsMessage=''
                            error={complianceRequestState.complianceRequestErrors.requestType}
                            errorLabel='Inserire protocollo richiesta'
                            label='Tipologia della Richiesta'
                            placeholder={'Seleziona Tipologia'}
                            options={tipologiaRichiestaComplianceRequest}
                            value={complianceRequestState.complianceRequestsCreation.requestType}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setRequestType(newValue))
                            }}
                        />
                        <MadfarmInput
                            label="Prodotto"
                            placeholder="Prodotto"
                            onChangeText={(text) => { dispatch(setRequestProduct(text)) }}
                        />
                    </div>
                    <div className="border-[0.5px] border-neutral-200" />
                    <CustomersOtherOdCAdd />
                    <TextArea
                        error={complianceRequestState.complianceRequestErrors.description}
                        supportingText={complianceRequestState.complianceRequestErrors.description ? 'Indicare Descrizione' : undefined}
                        label='Descrizione Richiesta'
                        onChangeText={(text) => { dispatch(setRequestDescription(text)) }}
                    />
                    <TextArea
                        label='Note'
                        onChangeText={(text) => { dispatch(setRequestNote(text)) }}
                    />
                </div>
            </div>
        </div>
    )
}